import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-menu-drawer',
  templateUrl: './menu-drawer.component.html',
  styleUrls: ['./menu-drawer.component.scss']
})
export class MenuDrawerComponent {
  @Input() headerTitle!: string;
  @Input() formInvalid = true;
  @Output() closeButtonClicked = new EventEmitter();
  constructor() {}

  ngOnInit() {}

  closeDrawer() {
    this.closeButtonClicked.emit('close-menu-drawer');
  }

}
